const Logo = ({ size = 64 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Subtle glow behind baseball */}
    <circle cx="40" cy="46" r="24" fill="#ecc94b" opacity="0.12" />

    {/* Baseball */}
    <circle cx="40" cy="46" r="20" fill="#faf5ef" stroke="#c53030" strokeWidth="2" />

    {/* Left seam */}
    <path
      d="M 32 28 C 24 36, 24 56, 32 64"
      stroke="#c53030"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />

    {/* Right seam */}
    <path
      d="M 48 28 C 56 36, 56 56, 48 64"
      stroke="#c53030"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />

    {/* Left stitch marks */}
    <g stroke="#c53030" strokeWidth="1" strokeLinecap="round">
      <line x1="29" y1="33" x2="25" y2="31" />
      <line x1="27" y1="38" x2="23" y2="37" />
      <line x1="25" y1="44" x2="21" y2="44" />
      <line x1="27" y1="50" x2="23" y2="51" />
      <line x1="28" y1="55" x2="24" y2="57" />
      <line x1="30" y1="60" x2="26" y2="62" />
    </g>

    {/* Right stitch marks */}
    <g stroke="#c53030" strokeWidth="1" strokeLinecap="round">
      <line x1="51" y1="33" x2="55" y2="31" />
      <line x1="53" y1="38" x2="57" y2="37" />
      <line x1="55" y1="44" x2="59" y2="44" />
      <line x1="53" y1="50" x2="57" y2="51" />
      <line x1="52" y1="55" x2="56" y2="57" />
      <line x1="50" y1="60" x2="54" y2="62" />
    </g>

    {/* Wizard hat body */}
    <path
      d="M 22 28 Q 30 10, 50 4 L 58 28 Z"
      fill="#2b3a8c"
      stroke="#1e2d6e"
      strokeWidth="1"
      strokeLinejoin="round"
    />

    {/* Wizard hat brim */}
    <ellipse
      cx="40"
      cy="28"
      rx="20"
      ry="5"
      fill="#3c4db0"
      stroke="#1e2d6e"
      strokeWidth="1"
    />

    {/* Star on hat */}
    <path
      d="M 42 8 L 43.5 12.5 L 48 13 L 44.5 16 L 45.5 20.5 L 42 17.5 L 38.5 20.5 L 39.5 16 L 36 13 L 40.5 12.5 Z"
      fill="#ecc94b"
    />

    {/* Sparkle dots */}
    <circle cx="10" cy="18" r="2" fill="#ecc94b" opacity="0.8" />
    <circle cx="70" cy="14" r="1.5" fill="#ecc94b" opacity="0.6" />
    <circle cx="6" cy="48" r="1.5" fill="#ecc94b" opacity="0.5" />
    <circle cx="74" cy="42" r="2" fill="#ecc94b" opacity="0.7" />

    {/* Cross sparkles */}
    <g stroke="#ecc94b" strokeWidth="1.5" strokeLinecap="round">
      <line x1="10" y1="34" x2="14" y2="34" opacity="0.7" />
      <line x1="12" y1="32" x2="12" y2="36" opacity="0.7" />
      <line x1="66" y1="28" x2="70" y2="28" opacity="0.6" />
      <line x1="68" y1="26" x2="68" y2="30" opacity="0.6" />
    </g>
  </svg>
);

export default Logo;
